import { Outlet } from '@tanstack/react-router';
import { ImpersonateBanner } from './ImpersonateBanner.js';

export function RootShell() {
  return (
    <div className="min-h-dvh bg-[#0a0a0f] text-zinc-100">
      <ImpersonateBanner />
      <Outlet />
    </div>
  );
}
